export default __webpack_public_path__ + "static/media/ContentLiberaryInactiveIcon.b3db29cc.svg";